export default {
  default: () => import("/opt/buildhome/repo/layouts/default.vue"),
  "non-grid": () => import("/opt/buildhome/repo/layouts/non-grid.vue")
}